<template>
    <div class="main-content">
        <alert ref="alert"></alert>

        <section class="section">
            <div class="sec-cst section-header bdr-20 mt-4">
                <h1 class="mt-0">
                    {{this.$route.meta.title}}
                </h1>
                <div class="section-header-breadcrumb">
                    <div class="button-modal text-right">
                        <router-link :to="{name:'subscriber-add'}"  class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Data</router-link>
                    </div>
                </div>
            </div>
            <div class="section-body mt-4">
                <div class="row mt-4">
                    <div class="col-12 text-center mt-3 hv-100" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-20">
                            <div class="card-header border-0 py-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getNewsletter()">
                                        </vue-search>
                                    </div>
                                </div>
                                <div class="button-modal text-right">
                                    <button  v-bind:class="loading_export ? 'btn-progress' : ''" class="btn btn-new2" @click="_exportNewsletter()"><i class="uil uil-file-export mr-2"></i> Export Excel</button>
                                </div>
                            </div>
                            <div class="card-body px-0 pb-0">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th width="20px">
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in newsletter.data" :key="data.id" v-on:click="editNewsletter(data)">
                                                <td width="20px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_newsletter" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>{{data.first_name}}</td>
                                                <td>{{data.last_name}}</td>
                                                <td>{{data.email}}</td>
                                                <td>
                                                    <label v-if="data.status === 'ACTIVE'" class="badge badge-success">{{data.status}}</label>
                                                    <label v-if="data.status === 'INACTIVE'"  class="badge badge-warning">{{data.status}}</label>
                                                </td>
                                                <td>{{data.created_at |  formatDate('MMMM DD, YYYY')}}</td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="newsletter.total === 0" class="text-center no-data">Newsletter data not found</p>
                                </div>
                            </div>
                            <div class="card-footer text-right">
                                <vue-pagination :pagination="newsletter"
                                                :sorting="sorting"
                                                @paginate="getNewsletter()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-20 py-5">
                            <div class="card-body card-nitem text-center py-5">
                                <img class="mb-4" width="150px" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h3>Newsletter Data Still Empty</h3>
                                    <p>Please create your client newsletter data on this page</p>
                                    <div class="tabel-action">
                                        <router-link :to="{name:'subscriber-add'}"  class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Data</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_newsletter.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_newsletter = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_newsletter.length}}</span> data selected</span>
                    </div>
                    <div class="float-right">
                        <div v-b-modal.modal-Alert class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <b-modal id="modal-Alert" hide-footer hide-header centered>
            <div class="text-center pt-2 pb-3 px-3">
                <i style="font-size: 60px; color: #f8d735;" class="uil uil-exclamation-triangle"></i>
                <h3 class="mt-1">Confirmation</h3>
                <p style="font-size:16px;">Are you sure to delete this data ? data that has been deleted cannot be returned</p>
                <div class="btn-alert mt-4">
                    <button @click="_deleteNewsletter()" v-bind:class="loading ? 'btn-progress' : ''" class="btn btn-danger mr-2">Sure</button>
                    <button @click="$bvModal.hide('modal-Alert')" class="btn btn-secondary">Cancel</button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations} from 'vuex'
    import VuePagination from "../../components/Pagination.vue";
    import VueSearch from "../../components/Search.vue";
    import Alert from "../../components/Alert.vue";
    import moment from 'moment'

    export default {
        components: {
            VuePagination,
            VueSearch,
            Alert
        },
        data(){
            return {
                no_data: null,
                loading:false,
                loading_export:false,
                del_newsletter:[],
            }
        },
        mounted(){
            this.getNewsletter().then(() => {
                if(this.newsletter.total == 0){
                    this.no_data = true
                }else{
                    this.no_data = false
                }
            })
        },
        filters: {
            formatDate: function(val,format){
                if(val){
                    return moment(String(val)).format(format)
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('NewsletterControl', {
                newsletter: state => state.newsletter,
                sorting: state => state.sorting,
                errors: state => state.errors,
            }),

            selectAll: {
                get: function () {
                    return this.newsletter.data ? this.del_newsletter.length == this.newsletter.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.newsletter.data.forEach(function (newsletter) {
                            selected.push(newsletter.id);
                        });
                    }
                    this.del_newsletter = selected;
                }
            }
        },
        methods: {
            ...mapActions('NewsletterControl', ['getNewsletter','deleteNewsletter','exportNewsletter']),
            ...mapMutations('NewsletterControl', ['ASSIGN_FORM']),

            editNewsletter: function(data){
                this.ASSIGN_FORM(data)
                this.$router.push({ name: 'subscriber-edit', params: { id: data.id } })
            },
            _deleteNewsletter:function(){
                this.loading = true
                this.deleteNewsletter(this.del_newsletter).then(() => {
                    this.loading = false
                    this.del_newsletter = []
                    this.$bvModal.hide('modal-Alert')
                    this.$refs.alert.showAlert('success','Successfully deleted subscriber data')
                })
            },
            _exportNewsletter() {
                this.loading_export = true
                this.exportNewsletter().then(response => {
                    let blob = new Blob([response], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'newsletter.xlsx'
                    link.click();
                    blob = null;
                    this.loading_export = false
                })
            },
        }
    }

</script>